import { render, staticRenderFns } from "./discountedArticlesIcon.vue?vue&type=template&id=7718aa68&scoped=true&"
import script from "./discountedArticlesIcon.vue?vue&type=script&lang=js&"
export * from "./discountedArticlesIcon.vue?vue&type=script&lang=js&"
import style0 from "./discountedArticlesIcon.vue?vue&type=style&index=0&id=7718aa68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7718aa68",
  null
  
)

export default component.exports